import { useQuery } from '@tanstack/react-query'
import storage from '../Storage'
import queryClient from '../queryClient'

const WHATS_NEW_VERSION_QUERY_OPTIONS_KEY = ['LAST_SHOW_WHATS_NEW_VERSION']
export function setLastShowWhatsNewVersion(value: string | null) {
	queryClient.setQueryData(WHATS_NEW_VERSION_QUERY_OPTIONS_KEY, value)
	storage.lastShowWhatsNewVersion = value
}
export function useLastShowWhatsNewVersion() {
	const { data } = useQuery<string | null>({
		queryKey: WHATS_NEW_VERSION_QUERY_OPTIONS_KEY,
		initialData: storage.lastShowWhatsNewVersion,
	})

	return [data, setLastShowWhatsNewVersion] as const
}
